import React, {useState} from 'react';
import {ChromePicker} from 'react-color';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import {withStyles} from '@material-ui/core';

const toRGBA = (color, defcolor = '#000000') => {
    return color && color.rgb ? 'rgba(' + color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b + ',' + color.rgb.a + ')' : defcolor;
};

const FormColor = ({...props}) => {

    const popover = {
        position: 'absolute',
        zIndex: '2',
    };
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    };

    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState(props.color || '#ffffff');

    return (
        <div>
            <IconButton
                onClick={() => setDisplayColorPicker(!displayColorPicker)}
            >
                <Icon style={{color: color, border: "1px solid gray"}}>color_lens</Icon>
            </IconButton>
            {displayColorPicker
                ? <div style={popover}>
                    <div style={cover} onClick={() => setDisplayColorPicker(false)}/>
                    <ChromePicker color={color} onChange={(colordata) => {
                        let rgba = toRGBA(colordata);
                        //console.log(rgba);
                        if (props.onChange) {
                            props.onChange(rgba);
                        }
                        setColor(rgba);
                    }}/>
                </div>
                : null}
        </div>
    );
};

const styles = theme => ({

    // dangerButton: {
    //     color: red[500],
    // },
});

export default withStyles(styles)(FormColor);
